import { CountryPhoneInputValue } from 'antd-country-phone-input/dist/typings';
import { CountryCode, isPossiblePhoneNumber } from 'libphonenumber-js';

export function handlePossiblePhoneNumberValidation(
  _: unknown,
  phoneNumber: CountryPhoneInputValue
): Promise<boolean> {
  if (phoneNumber && phoneNumber.phone) {
    const completePhoneNumber = phoneNumber.code?.toString() + ' ' + phoneNumber.phone;
    const isPhoneNumberPossible = isPossiblePhoneNumber(completePhoneNumber, {
      defaultCountry: phoneNumber.short as CountryCode,
      defaultCallingCode: phoneNumber.code?.toString(),
    });

    if (!isPhoneNumberPossible || (phoneNumber.code === 55 && phoneNumber.phone.length < 10)) {
      // TODO: TRADUZIR ISSO AQ NO FINAL
      return Promise.reject(new Error('Número de telefone inválido'));
    }
  }
  return Promise.resolve(true);
}

export function handleRequiredPhoneValidation(
  _: unknown,
  phoneNumber: CountryPhoneInputValue
): Promise<boolean> {
  if (!phoneNumber || !phoneNumber.phone) {
    // TODO: TRADUZIR ISSO AQ NO FINAL
    return Promise.reject(new Error('Por favor, preencha o campo Telefone'));
  }
  return Promise.resolve(true);
}
